// extracted by mini-css-extract-plugin
export default {"back":"fonts_back__wBcQT","globalFonts":"fonts_globalFonts__wQoCI","front":"fonts_front__ZU4Ma"};